import './Icon_Eye.css';

function Icon_Eye() {
  return (
    <div className='icon-container-eye'>
      <svg viewBox="0 0 24 24" className="eye-svg">
        <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    </div>
  );
}

export default Icon_Eye;